import { Record, List, Map } from 'immutable';

const ListingRecord = Record({
    currency: 'USD',
    expiresAt: null,
    id: null,
    isMonitored: false,
    marketplace: '',
    marketplaceId: '',
    metadata: Map({
        asin: '',
        previousRankings: List([]),
        rankings: List([]),
        rating: 0,
        reviewsCount: 0,
        reviewUrlChecked: false,
    }),
    price: null,
    productId: null,
    reviewUrl: '',
    shippingDaysMax: null,
    shippingDaysMin: null,
    shippingNote: '',
    shippingPrice: null,
    shippingType: null,
    url: '',
}, 'Listing');

function getAsin() {
    return this.getIn(['metadata', 'asin'], false);
}

ListingRecord.prototype.getAsin = getAsin;

export default ListingRecord;
